import { style } from "@vanilla-extract/css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";

/**
 * Base slide container styles
 * Provides consistent spacing and layout for all wizard slides
 */
export const slideContainerStyle = style({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacings.m,
  width: "100%",
  padding: "var(--padding)",
  overflow: "hidden",
});

export const slideHeadingDescriptionStyle = style({
  maxWidth: rem(480),
});

/**
 * Slide content area styles
 * Main content area with consistent spacing
 */
export const slideContentStyle = style({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacings.s,
  width: "100%",
});

/**
 * Two-column grid layout for form fields
 * Responsive grid that stacks on mobile and shows two columns on larger screens
 */
export const twoColumnGridStyle = style({
  gap: theme.spacings.s,
  gridTemplateColumns: "repeat(1, 1fr)",
  ...responsiveContainer({
    520: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: theme.spacings.m,
    },
  }),
});

// /**
//  * Form section styles
//  * Groups related form fields with consistent spacing
//  */
// export const formSectionStyle = style({
//   display: "flex",
//   flexDirection: "column",
//   gap: theme.spacings.s,
//   width: "100%",
// });

// /**
//  * Conditional content styles
//  * For content that appears/disappears based on form state
//  */
// export const conditionalContentStyle = style({
//   display: "flex",
//   flexDirection: "column",
//   gap: theme.spacings.s,
//   marginTop: theme.spacings.s,
//   paddingTop: theme.spacings.s,
//   borderTop: `1px solid ${theme.colors.softBorder}`,
// });

// /**
//  * Slide footer styles
//  * For any additional content at the bottom of slides
//  */
// export const slideFooterStyle = style({
//   marginTop: theme.spacings.l,
//   paddingTop: theme.spacings.m,
//   borderTop: `1px solid ${theme.colors.softBorder}`,
// });

// /**
